import { FC, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { JsonLd } from 'react-schemaorg';
import { BreadcrumbList, ListItem } from 'schema-dts';

import { useBreadcrumbContext } from '@/contexts/breadcrumb';

import { BreadcrumbItem, Nav, NextIcon, OrderList } from './style';

const BreadcrumbNav: FC = () => {
  const breadcrumbs = useBreadcrumbContext();

  if (breadcrumbs.length <= 0) {
    return <></>;
  }

  return (
    <Nav>
      {/* 構造化データ */}
      <JsonLd<BreadcrumbList>
        item={{
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: breadcrumbs.map((bc, i) => {
            const itemData: ListItem = {
              '@type': 'ListItem',
              position: i + 1,
              name: bc.name,
            };
            if (bc.to) {
              itemData.item = `${import.meta.env.VITE_BASE_URL}${bc.to}`;
            }
            return itemData;
          }),
        }}
      />
      <OrderList>
        {breadcrumbs.map((bc, i) => (
          <Fragment key={`breadcrumb-${bc.name}-${bc.to}`}>
            <BreadcrumbItem>
              {i === breadcrumbs.length - 1 ? (
                <span>{bc.name}</span>
              ) : (
                <Link to={bc.to}>{bc.name}</Link>
              )}
            </BreadcrumbItem>
            {i < breadcrumbs.length - 1 && <NextIcon />}
          </Fragment>
        ))}
      </OrderList>
    </Nav>
  );
};

export default BreadcrumbNav;
